import lista_actores from "@/assets/data/lista_actores.json";

const extensionMapaDefault = [
  -116.668130000000005, 18.5014099999999999, 9.8850700000000007, 57.0758399999999995,
];

export default {
  namespaced: true,
  state: () => ({
    cvesSector: [],
    cvesPais: [],
    cvesEdo: [],
    cvesLineaEstrategica: [],
    idsUbicacionesPuntos: [],
    extensionMapa: extensionMapaDefault,
    listaActoresVisible: false,
    sinInteraccionesAun: true,
    relacionActoresFiltrados: compactarActores(lista_actores),
  }),
  getters: {
    actualCvePais(state) {
      return state.cvesPais[0];
    },
    actualCveEdo(state) {
      return state.cvesEdo[0];
    },
    actualCveLineaEstrategica(state) {
      return state.cvesLineaEstrategica[0] ?? "00";
    },
    actualRelacionActoresFiltrados(state) {
      return (atributo) =>
        atributo === undefined
          ? JSON.parse(state.relacionActoresFiltrados)
          : JSON.parse(state.relacionActoresFiltrados).map((actor) => actor[atributo]);
    },
  },
  mutations: {
    cambiarCvesSector: (state, valor) => (state.cvesSector = validarArray(valor)),
    cambiarCvesPais: (state, valor) => (state.cvesPais = validarArray(valor)),
    cambiarCvesEdo: (state, valor) => (state.cvesEdo = validarArray(valor)),
    cambiarCvesLineaEstrategica(state, valor) {
      state.cvesLineaEstrategica = validarArray(valor).filter((v) => v !== "00");
    },
    cambiarIdsUbicacionesPuntos: (state, valor) =>
      (state.idsUbicacionesPuntos = validarArray(valor)),
    cambiarExtensionMapa: (state, valor) => (state.extensionMapa = valor),
    resetearExtensionMapa: (state) => (state.extensionMapa = extensionMapaDefault),
    cambiarListaActoresVisible(state, valor) {
      state.listaActoresVisible = valor === undefined ? !state.listaActoresVisible : valor;
    },
    resetearTodoMapa(state) {
      state.extensionMapa = extensionMapaDefault;
      state.cvesPais = [];
      state.cvesEdo = [];
      state.idsUbicacionesPuntos = [];
      state.relacionActoresFiltrados = compactarActores(lista_actores);
    },
    actualizarActoresFiltrados: (state) => filtarActores(state, false),
  },
  actions: {
    cambiarCvesSector({ commit }, valor) {
      commit("cambiarCvesSector", valor);
      commit("cambiarIdsUbicacionesPuntos", []);
      commit("actualizarActoresFiltrados");
    },
    cambiarCvesPais({ commit }, valor) {
      commit("cambiarCvesPais", valor);
      commit("cambiarIdsUbicacionesPuntos", []);
      commit("actualizarActoresFiltrados");
    },
    cambiarCvesEdo({ commit }, valor) {
      commit("cambiarCvesEdo", valor);
      commit("cambiarIdsUbicacionesPuntos", []);
      commit("actualizarActoresFiltrados");
    },
    cambiarCvesLineaEstrategica({ commit }, valor) {
      commit("cambiarCvesLineaEstrategica", valor);
      commit("cambiarIdsUbicacionesPuntos", []);
      commit("actualizarActoresFiltrados");
    },
    cambiarIdsUbicacionesPuntos({ commit }, valor) {
      commit("cambiarIdsUbicacionesPuntos", valor);
      commit("actualizarActoresFiltrados");
    },
  },
};

function validarArray(valor) {
  return valor === undefined ? [] : Array.isArray(valor) ? valor : [valor];
}

function filtroIncludes(storeValue, objValue) {
  return storeValue.length > 0 ? storeValue.includes(objValue) : true;
}

function compactarActores(actores) {
  return JSON.stringify(actores.map((actor) => new relActor(actor.g_id, actor.id_ubicacion)));
}

function filtarActores(state, imprimirEsrado) {
  if (imprimirEsrado) {
    console.log(
      `lin: ${JSON.stringify(state.cvesLineaEstrategica)}, sect: ${JSON.stringify(
        state.cvesSector
      )}, pais: ${JSON.stringify(state.cvesPais)}, edo: ${JSON.stringify(state.cvesEdo)}, geo: ${
        state.idsUbicacionesPuntos.length
      }`
    );
  }

  if (state.sinInteraccionesAun) {
    state.listaActoresVisible = true;
    state.sinInteraccionesAun = false;
  }

  state.relacionActoresFiltrados = compactarActores(
    lista_actores.filter(
      (actor) =>
        filtroIncludes(state.cvesLineaEstrategica, actor.id_linea_estrategica) &&
        filtroIncludes(state.cvesSector, actor.id_sector) &&
        filtroIncludes(state.cvesPais, actor.codigo_pais) &&
        filtroIncludes(state.cvesEdo, actor.cve_ent) &&
        filtroIncludes(state.idsUbicacionesPuntos, actor.g_id)
    )
  );
}

/**
 * Esta clase sirve para guardar la relación de los actores filtrados con
 * sus respectivas lineas estratégicas y sus ubicaciones conforme al store
 */
class relActor {
  constructor(id, geo) {
    this.g_id = id;
    this.geo = geo; /* deprecated */
  }
}
